import { apiPost } from './apiHelper';
import _ from 'lodash';

export function persistCheckout(sessionId, requestPayload, cb) {
    apiPost('/api/v1/PersistCheckout', { checkoutData: requestPayload, sessionId }, (err, data) => {
        cb(err, data);
    });
}

export function getNextCheckoutUrl(sessionId, partial, cb) {
    apiPost(
        `/api/v1/getNextCheckoutUrl/${partial}`,
        {
            sessionId,
        },
        (hasErr, response) => {
            cb(hasErr, response);
        }
    );
}

export const CURRENCY = 'EUR';
export const PAYPAL_INTENT_AUTHORIZE = 'capture';

export function createPayPalOrder({ cart, hasNoShipping = false }) {
    const { products } = cart;
    const items = products
        .filter(product => product.selectedLieferweg && product.selectedLieferweg.legalType === 'online-kauf')
        .map(p => {
            return {
                name: _.truncate(p.bezeichnung, { length: 127 }),
                quantity: p.quantity,
                unit_amount: {
                    currency_code: CURRENCY,
                    value: ((p.vk_preis || p.selectedBezugsquelle?.vk_preis || 0) + (p.batterieDeposit || 0)).toFixed(2),
                },
            };
        });

    const discount = _.get(cart, 'stats.onlineKauf.discount', 0);

    return {
        intent: PAYPAL_INTENT_AUTHORIZE.toUpperCase(),
        ...(hasNoShipping && {
            application_context: {
                shipping_preference: 'NO_SHIPPING',
            },
        }),
        purchase_units: [
            {
                amount: {
                    value: _.get(cart, 'stats.onlineKauf.grossTotal', 0),
                    currency_code: CURRENCY,
                    breakdown: {
                        item_total: {
                            value: _.get(
                                cart,
                                discount ? 'stats.onlineKauf.preDiscountStats.grossProducts' : 'stats.onlineKauf.grossProducts',
                                0
                            ),
                            currency_code: CURRENCY,
                        },
                        shipping: {
                            value: _.get(cart, 'stats.onlineKauf.shippingCost', 0),
                            currency_code: CURRENCY,
                        },
                        discount: {
                            value: discount,
                            currency_code: CURRENCY,
                        },
                    },
                },
                items,
                reference_id: "APS",
                description: 'Onlinebestellung Autoteileplusservice',
            },
        ],
    };
}
